import { createContext } from 'react'
import { TourMarketingStore } from './tourMarketingStoreTypes'

export const TourMarketingContext = createContext<TourMarketingStore | null>(null)
